import React, { createContext, useContext, useState } from "react";
import api from "../services/api";
import { requestFirebaseToken } from "../config/firebase";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem("lash_user");
    return saved ? JSON.parse(saved) : null;
  });
  const [token, setToken] = useState(() => localStorage.getItem("lash_token"));
  const [loading, setLoading] = useState(false);

  const login = (userData, authToken) => {
    setUser(userData);
    setToken(authToken);
    localStorage.setItem("lash_user", JSON.stringify(userData));
    localStorage.setItem("lash_token", authToken);
    // Request push notification permission after login
    setTimeout(() => requestFirebaseToken(), 1500);
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem("lash_user");
    localStorage.removeItem("lash_token");
  };

  const refreshProfile = async () => {
    try {
      const { data } = await api.get("/auth/profile");
      if (data.success) {
        setUser(data.user);
        localStorage.setItem("lash_user", JSON.stringify(data.user));
      }
    } catch {}
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        loading,
        setLoading,
        login,
        logout,
        refreshProfile,
        isAdmin: user?.role === "admin",
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
